import { axiosBaseURL } from "../http";

class ChatGPTStore {
    static _apiKey;
    
    static async getApiKey() {
        if (!this._apiKey) {
            try {
                const data = await axiosBaseURL.get("common/client_properties/?name=chatgpt_key");
                this._apiKey = data.data.property ?? null;
            }
            catch (ex) {
                return this._apiKey;
            }
        }
        return this._apiKey;
    }
}
export default ChatGPTStore;